import { render, staticRenderFns } from "./Supplier-messaging.vue?vue&type=template&id=143acbe1&scoped=true&"
import script from "./Supplier-messaging.vue?vue&type=script&lang=js&"
export * from "./Supplier-messaging.vue?vue&type=script&lang=js&"
import style0 from "./Supplier-messaging.vue?vue&type=style&index=0&id=143acbe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143acbe1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDialog,VIcon,VImg,VSpacer,VTab,VTabItem,VTabs,VToolbar,VToolbarTitle})
